/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useRef, useEffect, useState } from 'react';
import { graphql } from 'gatsby';

import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainContentWrapper,
  Title,
  Text,
  ContentContainer,
  ImageSection,
  Image,
  Video,
  ContentSection,
  CardContainer,
  CardImage,
  CardContentContanier,
  CardTitle,
  CardText,
  ContentSectionMobile,
  CardContainerMobile,
  CardContentContanierMobile,
} from './styled';

interface Props {
  // hasScrolled: boolean;
  showVideo: boolean;
}

const GuideHome: FC<Props & Queries.SeoGuideHomeFragment> = ({
  guideHome,
  // hasScrolled,
  showVideo,
}) => {
  const { title, subtitle, image, steps } = guideHome || {};
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState('');

  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      setVideoSrc('/images/buy-crypto.mp4');
    } else {
      setVideoSrc('/images/buy-crypto.webm');
    }
  }, []);

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <MainContentWrapper>
            <Title>{title}</Title>
            <Text>{subtitle}</Text>
          </MainContentWrapper>
          <ContentContainer>
            <ImageSection>
              {/* Both elements stay in DOM to prevent CLS - CSS handles visibility */}
              {/* <Image
                src={image?.src ?? undefined}
                alt={image?.alt ?? undefined}
                width="345"
                height="496"
                loading="eager"
                $hidden={showVideo}
              /> */}
              <Video
                ref={videoRef}
                autoPlay
                preload="auto"
                loop
                muted
                playsInline
                disablePictureInPicture
                $hidden={!showVideo}
                width="345"
                height="496"
              >
                {videoSrc && (
                  <source
                    src={videoSrc}
                    type={
                      videoSrc.endsWith('.webm') ? 'video/webm' : 'video/mp4'
                    }
                  />
                )}
                <Image
                src={image?.src ?? undefined}
                alt={image?.alt ?? undefined}
                width="345"
                height="496"
                loading="eager"
                $hidden={showVideo}
              />
              </Video>
            </ImageSection>
            {steps && (
              <ContentSection>
                {steps.map(step => (
                  <CardContainer key={step?.title}>
                    <CardImage
                      src={step?.image?.src ?? undefined}
                      alt={step?.image?.alt ?? undefined}
                      width="60"
                      height="60"
                    />
                    <CardContentContanier>
                      <CardTitle>{step?.title}</CardTitle>
                      <CardText>{step?.description}</CardText>
                    </CardContentContanier>
                  </CardContainer>
                ))}
              </ContentSection>
            )}
            {steps && (
              <ContentSectionMobile>
                {steps.map(step => (
                  <CardContainerMobile key={step?.title}>
                    <CardContentContanierMobile>
                      <CardImage
                        src={step?.image?.src ?? undefined}
                        alt={step?.image?.alt ?? undefined}
                        width="48"
                        height="48"
                      />
                      <CardTitle>{step?.title}</CardTitle>
                    </CardContentContanierMobile>
                    <CardText>{step?.description}</CardText>
                  </CardContainerMobile>
                ))}
              </ContentSectionMobile>
            )}
          </ContentContainer>
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const query = graphql`
  fragment SeoGuideHome on Json {
    guideHome {
      title
      subtitle
      image {
        src
        alt
      }
      steps {
        title
        description
        image {
          src
          alt
        }
      }
    }
  }
`;

export default GuideHome;
